import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, Platform, ViewController, AlertController, } from 'ionic-angular';
import { StoryProvider } from '../../providers/story/story';
import { AuthDataProvider } from '../../providers/auth-data/auth-data';
import { Storage } from '@ionic/storage';
import { Content } from 'ionic-angular';
import { HomePage } from "../home/home";
import { AdsPage } from "../ads/ads";
import * as firebase from 'firebase';
import 'firebase/firestore';
import { AngularFirestore } from 'angularfire2/firestore';

@IonicPage({
  name: 'something-else'
})
@Component({
  selector: 'page-story',
  templateUrl: 'story.html',
})
export class StoryPage {
  @ViewChild(Content) grid: Content;
  @ViewChild(Content) content: Content;
  @ViewChild(Content) box: Content;


  public storie: any = {};
  public storieID: any;
  public userInfo: any;
  public messages: any;
  public messagesOnView = [];
  public percentToPayView = 35; // Porcentaje a tomar de msj para sacar vista de pago
  public percentToShowAll = 50; // Porcentaje a tomar de msj para mostrar el boton de ShowAllMessages
  public afterPercentToPay = null;
  public afterPercentToShow = null;
  public showAll: boolean = false;
  public countToShowPay = null;
  public countToShowAll = null;
  private db: any;
  public reading: any;
  public title: string;
  public view: any;
  public story_id: any;
  public session: any;
  public userlogged: any;
  public userReading: any;
  public capterLength: any;


  constructor(public platform: Platform,
    public afsModule: AngularFirestore,
    public params: NavParams,
    public viewCtrl: ViewController,
    public navCtrl: NavController,
    public navParams: NavParams,
    public storyProvider: StoryProvider,
    public auth: AuthDataProvider,
    private storage: Storage,
    public alertController: AlertController) {

    //console.log("CAPTURANDO URL", window.location.href);


    this.db = firebase.firestore();
    let ion = this;
    var data = this.navParams.get('data');
    //console.log("DATA", data);


    if (data) {
      ion.storie = data.storie; //console.log("INFORMACION STORIE: constructor", ion.storie);
      ion.capterLength = data.storie.chapters.length; //console.log("LONGITUD", ion.capterLength);
      ion.navParams.data.historyID = ion.storie.$key;
      ion.session = data.session;//console.log("Hay usuario Logueado: constructor", ion.session);
      ion.userInfo = data.userInfo; //console.log("Informacion de Usuario Logueado: constructor", ion.userInfo);
      ion.storieID = data.storie.$key; //console.log("ion.storieID", ion.storieID);
      ion.title = data.storie.title; //console.log("ion.title", ion.title);
      ion.view = data.storie.view;// console.log(" ion.view", ion.view);
      ion.session = data.session; //console.log("ion.session", ion.session);
      ion.userlogged = data.userinfo; //console.log(" ion.userlogged", ion.userlogged);

      if (this.session) {
        this.userReading = data.userinfo.reading
      } else {
        console.log("NO EXISTE USUARIO LOGUEADO");
      }
    }
  }

  ionViewDidLoad() {
    let ion = this;
    ion.auth.getUserProfile().then(resdevice => {
      ion.userInfo = resdevice
      //console.log("READDDDIINGGGGGG ", resdevice.reading)
    });
    ion.getStoryMessages().then(res => {
      ion.getLastMessageReaded();
      setTimeout(() => {
        this.gotoBottom('scrollID');
      }, 200);

      if (this.userReading) {
        console.log("Sin tutorial, ya usuario ha leido historias.");
      } else {
        ion.showTutorial();
      }
    });
  }

  ionViewWillLeave() {

    if (this.session) {
      this.saveLastMessageReaded();
      // this.saveView();
    } else {
      console.log("No existe Usuario Logueado");
    }
  }

  getStoryMessages(): Promise<any> {
    return new Promise((resolve, reject) => {
      let ion = this;
      ion.storyProvider.getStoryMessages(ion.storieID)
        .then(result => {
          //console.log("storieID", ion.storieID);
          // console.log('CHATTTTT', result);
          ion.messages = ion.injectActorsInMessages(result);
          ion.afterPercentToPay = (ion.percentToPayView * result.messages.length / 100)
          ion.afterPercentToPay = parseInt(ion.afterPercentToPay);

          ion.afterPercentToShow = (ion.percentToShowAll * result.messages.length / 100)
          ion.afterPercentToShow = parseInt(ion.afterPercentToShow);
          resolve(true);
        })
        .catch(err => {
          console.error('Error obtaining messages data.', err);
        });
    })
  }

  /////TUTORIAL HOW TO READ HISTORIES/////
  async showTutorial() {
    let ion = this;
    let alert;
    if (ion.platform.is('ios') || ion.platform.is('android')) {
      alert = await this.alertController.create({
        title: 'Tutorial',
        subTitle: 'Stories tutorial',
        message: 'Toca para leer mensajes.',
        buttons: ['OK'],
        cssClass: 'alertCustomCss1'
      });
    } else {
      alert = await this.alertController.create({
        title: 'Tutorial',
        subTitle: 'Stories tutorial',
        message: 'Click para leer mensajes.',
        buttons: ['OK'],
        cssClass: 'alertCustomCss3'
      });
    }
    await alert.present();
  }
  /////END TUTORIAL HOW TO READ HISTORIES/////

  injectActorsInMessages(messages) {
    messages.messages.forEach(message => {
      message.actor = messages.actors[message.actor_id];
    });
    return messages;
  }

  showAllMessage() {
    //console.log("MOSTRANDO TODOS LOS MENSAJES");
    let ion = this;
    if (ion.messages) {
      ion.messagesOnView = ion.messages.messages;
      // console.log("Mostrando todos los mensajes", ion.messagesOnView);

    }
  }

  showNewMessage() {
    let ion = this;
    // Logic for show pay view
    ion.countToShowPay++;
    if (ion.countToShowPay == ion.afterPercentToPay) {
      ion.countToShowPay = 0;
      ion.navCtrl.push(AdsPage);
    }

    ion.countToShowAll++;
    if (ion.countToShowAll == ion.afterPercentToShow) {
      this.showAll = true;
    }
    //console.log("Porcentaje de la Historia", ion.countToShowPay);

    let actualIndex = ion.messagesOnView.length;

    if (ion.messages) {
      if (ion.messages.messages[actualIndex]) {
        ion.messagesOnView.push(ion.messages.messages[actualIndex]);
        // console.log('ion.messages.messages[actualIndex]', ion.messages.messages[actualIndex]);

        setTimeout(() => {
          this.gotoBottom('scrollID');
        }, 200);
      } else {


        if (ion.capterLength > 1) {
          // this.presentAlertCondition2()
          this.presentAlertCondition()
        } else {
          this.presentAlertCondition()
        }

        this.saveView()
      }
      //console.log('ion.messagesOnViewion.messagesOnView', ion.messagesOnView);
      setTimeout(() => {
        this.gotoBottom('scrollID');
      }, 200);
    } else {
      alert("NO EXISTEN MENSAJES")
    }
    setTimeout(() => {
      this.gotoBottom('scrollID');
    }, 200);
  }


  copyLink(str) {
    // Create new element
    var el = document.createElement('textarea');
    // Set value (string to be copied)
    el.value = str;
    // Set non-editable to avoid focus and move outside of view
    el.setAttribute('true', '');
    // el.style = {
    //   position: 'absolute',
    //   left: '-9999px'
    // };
    document.body.appendChild(el);
    // Select text inside element
    el.select();
    // Copy text to clipboard
    document.execCommand('copy');
    // Remove temporary element
    document.body.removeChild(el);
  }


  share(socialNetwork) {
    let link = window.location.href;
    let config = "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes";
    let sharer = '';
    switch (socialNetwork) {
      case 'facebook':
        sharer = 'https://www.facebook.com/sharer/sharer.php?u=' + link;
        //console.log("Compartiendo Historia", socialNetwork);
        break;
      case 'twitter':
        sharer = 'https://twitter.com/share?text=Watch Our history! &url=' + link + '&hashtags=dirtyTalk,Sex,Porn';
        // console.log("Compartiendo Historia", socialNetwork);
        break;
      default:
        alert('Link of your history is copied')
        this.copyLink(link);
        break;
    }
    window.open(sharer, "Share Storie Facebook", config)
      //console.log("Compartiendo Historia", socialNetwork);
      ;
  }



  saveLastMessageReaded() {
    let ion = this;
    let actualIndex = ion.messagesOnView.length;
    // SALVANDO LINEA E HISTORIA EN EL STORAGE
    ion.storage.set(ion.storieID, actualIndex);

    //console.log("LINEA ACTUAL", actualIndex);
    //console.log("HISTORIA", ion.storieID);

    if (this.session) {
      // SALVANDO LINEA E HISTORIA EN FS
      ion.db.collection("users").doc(ion.userInfo.userID).update({
        reading: [
          {
            line: actualIndex,
            story_id: ion.storieID
          }
        ]
      }).then(function () {
        //console.log("Storie and Line successfully written!");
      })
        .catch(function (error) {
          //console.error("Error saving Storie and Line: ", error);
        });
    } else {
      // console.log("NO EXISTE USUARIO LOGUEADO");

    }
  }

  gotoBottom(id) {
    var element = document.getElementById(id);
    element.scrollTop = element.scrollHeight - element.clientHeight;
  }

  getLastMessageReaded() {
    let ion = this;
    ion.storage.get(ion.storieID).then(actualIndex => {
      for (let index = 0; index < actualIndex; index++) {
        ion.messagesOnView.push(ion.messages.messages[index]);
      }
    });
    this.gotoBottom('scrollID');
  }

  presentAlertCondition() {
    let ion = this;
    console.log(this.view + 1);

    return new Promise((Resolve, Reject) => {
      let alert = this.alertController.create({
        enableBackdropDismiss: false,
        cssClass: 'alertCustomCss3',
        title: 'Esta Historia ha llegado a su Fin...',
        message: "Te invitamos a seguir disfrutando de otras historias.",
        buttons: [
          {
            text: "Ir a Home.",
            handler: () => {
              console.log('Usuario Finalizo esta historia');
              ion.navCtrl.setRoot(HomePage);
              Resolve(true)
            }
          }]
      });
      alert.present();
    })
  }

  // presentAlertCondition2() {
  //   let ion = this;
  //   console.log(this.view + 1);

  //   return new Promise((Resolve, Reject) => {
  //     let alert = this.alertController.create({
  //       enableBackdropDismiss: false,
  //       cssClass: 'alertCustomCss3',
  //       title: 'Esta Historia ha llegado a su Fin...',
  //       message: "Te invitamos a seguir disfrutando de otras historias.",
  //       buttons: [
  //         {
  //           text: "Leer mas Historias",
  //           handler: () => {
  //             console.log('Usuario Finalizo esta historia');
  //             ion.navCtrl.setRoot(HomePage);
  //             Resolve(true)
  //           }
  //         },
  //         {
  //           text: "Siguiente Capitulo",
  //           handler: () => {
  //             console.log('En camino al Siguiente Capitulo.');
  //             ion.navCtrl.setRoot(HomePage);
  //             Resolve(true)
  //           }
  //         }]
  //     });
  //     alert.present();
  //   })
  // }

  saveView() {
    let ion = this;
    ion.storyProvider.saveView(this.storieID, this.view);
  }
}




// WEBPACK FOOTER //
// ./src/pages/story/story.ts